/**
 * App component.
 * 
 * This component sets up the router and global providers, including:
 * - AuthProvider for managing authentication and session.
 * - Routes to handle authentication callback and protected application routes.
 * - Custom event listener for breadcrumb navigation events.
 * 
 * Example usage:
 * 
 * <App />
 * 
 * @module App
 */

import React, { Suspense } from 'react';
import { BrowserRouter, Route, Routes } from 'react-router-dom';
import { AuthProvider } from './context/AuthContext';
import AuthCallback from './pages/AuthCallback';
import Shell from './shell/Shell';
import Loader from './components/Loader';
import DenyAccess from './pages/DenyAccess';
import { useBreadcrumbNavigation } from './utils/navigationHooks';
// const RemoteHomePageMap = React.lazy(() => import('remote/HomePageMap'));

// Component that handles all routing
const AppRoutes = () => {
    return (
        <Suspense fallback={<Loader />}>
            <Routes>
                <Route path="/auth/callback" element={<AuthCallback />} />
                <Route path="/denyAllAccess" element={<DenyAccess />} />
                <Route
                    path="/*"
                    element={
                        <AuthProvider>
                            {/* <Routes>
                                <Route path="/" element={<ProtectedRoute component={RemoteHomePageMap} />} />
                            </Routes> */}
                            <Shell />
                        </AuthProvider>
                    }
                />
            </Routes>
        </Suspense>
    );
};

// Component that sets up navigation hook for ALL routes
const AppWithNavigation = () => {
    // This hook is now active for all routes, not just protected ones
    useBreadcrumbNavigation();

    return <AppRoutes />;
};

const App = () => {
    return (
        <BrowserRouter>
            <AppWithNavigation />
        </BrowserRouter>
    );
};

export default App;